export const repair_edit_form = {
  part_to_repair_label: "Part to repair",
  cost_label: "Approx. cost",
  shop_label: "Repair shop",
  work_order_label: "Work order",
  notes_label: "Notes",
  notes_placeholder: "Optional notes",
};
